import React from 'react';
const ContentAssistantLeft = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#4C6AFF';
    delete attribute.stroke;
    return (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M5.86719 5H11.8672", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M5.86719 7.5H8.86719", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M9.36719 14.5H3.86719C3.59105 14.5 3.36719 14.2761 3.36719 14V2C3.36719 1.72386 3.59105 1.5 3.86719 1.5H13.8672C14.1433 1.5 14.3672 1.72386 14.3672 2V7", stroke: stroke, "stroke-linecap": "round" }),
        React.createElement("path", { d: "M11.8672 13.6992L9.86719 11.6992M9.86719 11.6992L11.8672 9.69922M9.86719 11.6992L14.8672 11.6992", stroke: stroke, "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
export default ContentAssistantLeft;
